import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { CustomEditButton } from '../../custom-edit-button/custom-edit-button.component';
import { CustomDeleteButton } from '../../custom-delete-button/custom-delete-button.component';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { ButtonColumnType, DataColumnType, IButtonColumn, IDataColumn, Severity } from '../../../../../shared/interfaces/custom-work/customTable';
import {DEFAULT_DATE_FORMAT, Utils} from '../../../../../shared';
import { CustomTableCheck } from '../../custom-table-check/custom-table-check.component';
import { CustomTableTypeChecker } from '../../../../../shared/classes/custom-table-type-checker';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';
import { TagModule } from 'primeng/tag';
import { ExcelFormatPipe } from "../../../../../pipes/excel-format.pipe";

@Component({
  selector: 'tr[tableBody]',
  standalone: true,
  imports: [CommonModule, CustomEditButton, CustomDeleteButton, TableModule, ButtonModule, CustomTableCheck, TranslateModule, TooltipModule, TagModule, ExcelFormatPipe],
  templateUrl: './table-body.component.html',
  styleUrl: './table-body.component.scss'
})
export class TableBodyComponent<T = any> {

  @Input() columns !: (IDataColumn | IButtonColumn<T>)[];
  @Input() rowData !: any;
  @Input() expanded !: boolean;

  tabletypeChecker = CustomTableTypeChecker;

  readonly defaultDateFormat = DEFAULT_DATE_FORMAT;
  readonly DataColumnType = DataColumnType;
  readonly ButtonColumnType = ButtonColumnType;

  getTramiteEstadoTagIcon(estado: string, usuarioAsignadoCorreo: string): string {
    return Utils.getTramiteEstadoTagIcon(estado, usuarioAsignadoCorreo);
  }

  getTramiteEstadoTagSeverity(estado: string, usuarioAsignadoCorreo: string): 'success' | 'secondary' | 'info' | 'warning' | 'danger' | 'contrast' {
    return Utils.getTramiteEstadoTagSeverity(estado, usuarioAsignadoCorreo);
  }

  getDisabled(col: IButtonColumn<T>): boolean{
    if(col.disabled){
      return col.disabled;
    }else if(col.getDisabled){
      return col.getDisabled(this.rowData);
    }
    return false;
  }

  getSeverity(col: IButtonColumn<T>): Severity {
    if(col.severity){
      return col.severity;
    }else if (col.getSeverity){
      return col.getSeverity(this.rowData);
    }
    return 'primary';
  }

  truncateLabel(text: string, maxLength: number = 20): string {
    if (!text || text.length <= maxLength) {
      return text;
    }
    return text.slice(0, maxLength).trimEnd() + '...';
  }

  protected readonly Number = Number;
  protected readonly isNaN = isNaN;
}
